import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  accessingCurrentSpaceAsStaff,
  commonRoomPostsExcludingRecentImportantSelector,
  participantCount,
  recentImportantPostsSelector,
} from '@core/selectors/classroom';
import { getCurrentSpaceId } from '@core/selectors/space';
import CommonRoomResponsive from './CommonRoomResponsive';

export const responsiveCommonRoomPostsSelector = createSelector(
  [
    recentImportantPostsSelector,
    commonRoomPostsExcludingRecentImportantSelector,
  ],
  (recentPosts, posts) => [...recentPosts, ...posts].filter(Boolean)
);

const mapStateToProps = (state) => ({
  participantTotal: participantCount(state),
  spaceId: getCurrentSpaceId(state),
  readOnly: accessingCurrentSpaceAsStaff(state),
  posts: commonRoomPostsExcludingRecentImportantSelector(state),
});

export default connect(mapStateToProps)(CommonRoomResponsive);
